export enum ToastType {
  SUCCESS = "success",
  ALERT = "alert",
  OFFLINE = "offline",
  INFO = "info",
}

interface ToastConfig {
  msg: string;
  type: ToastType;
  duration?: number;
  relative_to?: {
    el: HTMLElement;
    position: "top" | "bottom" | "left" | "right";
  };
  action?: {
    name: string;
    onClick: () => void;
  };
}

export const UseToast = (() => {
  let listener = (c: ToastConfig) => {
    /*  */
  };

  function listenForToastMsgs(fn: (c: ToastConfig) => void) {
    listener = fn;
  }

  function show(config: ToastConfig) {
    listener(config);
  }

  return () => {
    return { show, listenForToastMsgs };
  };
})();
// @ts-ignore
window.toasts = {
  simple: (msg: string, time = 3000) => {
    UseToast().show({
      type: ToastType.SUCCESS,
      msg,
      duration: time,
    });
  },
  ok: (action: { name: string; onClick: () => void }, duration = 1000) => {
    UseToast().show({
      type: ToastType.SUCCESS,
      msg: "finished generating your report",
      duration: duration,
      action,
    });
  },
  alert: (msg = "something") => {
    UseToast().show({
      type: ToastType.ALERT,
      msg: msg,
      duration: 4000,
    });
  },
  info: (msg: string, duration = 4000) => {
    UseToast().show({
      type: ToastType.INFO,
      msg: msg,
      duration,
    });
  },
  offline: () => {
    UseToast().show({
      type: ToastType.OFFLINE,
      msg: "this is so cool",
      duration: 4000,
    });
  },
};
